import MsecDuratives from '../../../modules/MsecDuratives.js';

class VideoTimeRange extends MsecDuratives {
  static name = 'VideoTimeRange';
}

export default VideoTimeRange;
